// Import and use some of the 'solid', 'regular', 'light' and 'brand' themes of FontAwesome 5 Free/PRO (.npmrc is required)
// We only add icons to the library that we actually use in frontend to keep the bundle size as small as possible
import { library, dom } from '@fortawesome/fontawesome-svg-core'

// Regular icons
import { faAngleLeft as farAngleLeft } from '@fortawesome/pro-regular-svg-icons/faAngleLeft'
import { faAngleRight as farAngleRight } from '@fortawesome/pro-regular-svg-icons/faAngleRight'
import { faSearch } from '@fortawesome/pro-regular-svg-icons/faSearch'
import { faBars } from '@fortawesome/pro-regular-svg-icons/faBars'
import { faFile } from '@fortawesome/pro-regular-svg-icons/faFile'
import { faImage } from '@fortawesome/pro-regular-svg-icons/faImage'

// Solid icons
import { faExclamationTriangle } from '@fortawesome/pro-solid-svg-icons/faExclamationTriangle'
import { faCheck } from '@fortawesome/pro-solid-svg-icons/faCheck'
import { faTriangle } from '@fortawesome/pro-solid-svg-icons/faTriangle'
import { faSquare } from '@fortawesome/pro-solid-svg-icons/faSquare'
import { faFont } from '@fortawesome/pro-solid-svg-icons/faFont'
import { faCircle } from '@fortawesome/pro-solid-svg-icons/faCircle'

// Light icons
import { faAngleLeft as falAngleLeft } from '@fortawesome/pro-light-svg-icons/faAngleLeft'
import { faAngleRight as falAngleRight } from '@fortawesome/pro-light-svg-icons/faAngleRight'
import { faAngleUp } from '@fortawesome/pro-light-svg-icons/faAngleUp'
import { faAngleDown } from '@fortawesome/pro-light-svg-icons/faAngleDown'
import { faTimes } from '@fortawesome/pro-light-svg-icons/faTimes'
import { faGlobe } from '@fortawesome/pro-light-svg-icons/faGlobe'
import { faMapMarkerAlt } from '@fortawesome/pro-light-svg-icons/faMapMarkerAlt'
import { faDownload } from '@fortawesome/pro-light-svg-icons/faDownload'
import { faEnvelope } from '@fortawesome/pro-light-svg-icons/faEnvelope'
import { faPhone } from '@fortawesome/pro-light-svg-icons/faPhone'
import { faExternalLink } from '@fortawesome/pro-light-svg-icons/faExternalLink'
import { faInfoCircle } from '@fortawesome/pro-light-svg-icons/faInfoCircle'
import { faFileAlt } from '@fortawesome/pro-light-svg-icons/faFileAlt'
import { faFilePdf } from '@fortawesome/pro-light-svg-icons/faFilePdf'
import { faCheckCircle } from '@fortawesome/pro-light-svg-icons/faCheckCircle'
import { faHome } from '@fortawesome/pro-light-svg-icons/faHome'
import { faFax } from '@fortawesome/pro-light-svg-icons/faFax'
import { faEllipsisH } from '@fortawesome/pro-light-svg-icons/faEllipsisH'
import { faNewspaper } from '@fortawesome/pro-light-svg-icons/faNewspaper'
import { faCircleNotch } from '@fortawesome/pro-light-svg-icons/faCircleNotch'
import { faExternalLink } from '@fortawesome/pro-light-svg-icons/faExternalLink'

// Brand icons
import { faFacebookF } from '@fortawesome/free-brands-svg-icons/faFacebookF'
import { faInstagram } from '@fortawesome/free-brands-svg-icons/faInstagram'
import { faYoutube } from '@fortawesome/free-brands-svg-icons/faYoutube'
import { faTwitter } from '@fortawesome/free-brands-svg-icons/faTwitter'
import { faLinkedinIn } from '@fortawesome/free-brands-svg-icons/faLinkedinIn'
import { faVimeoV } from '@fortawesome/free-brands-svg-icons/faVimeoV'

// Add imported icons to the library
library.add(
    farAngleLeft, farAngleRight, faSearch, faBars, faFile, faImage,
    faExclamationTriangle, faCheck, faTriangle, faSquare, faFont, faCircle,
    falAngleLeft, falAngleRight, faAngleUp, faAngleDown, faTimes, faGlobe, faMapMarkerAlt, faDownload, faEnvelope, faPhone,
    faExternalLink, faInfoCircle, faFileAlt, faFilePdf, faCheckCircle, faHome, faFax, faEllipsisH, faNewspaper, faCircleNotch, faExternalLink,
    faFacebookF, faInstagram, faYoutube, faTwitter, faLinkedinIn, faVimeoV
)

// Kicks off the process of finding <i> tags and replacing with <svg>
dom.watch()
